import { ButtonContained } from 'shared/ui/buttons/buttonContained'
import styles from './PhoneModal.module.scss'
import { ChangeEvent, FC, useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useHookFormMask } from 'use-mask-input';
import ReactDOM from 'react-dom';
import { bookingStore } from 'entities/booking';

type PhoneModalProps = {
  isOpen?: boolean;
  onConfirm?: () => void
}

type FormValues = {
  phone: string;
}

export const PhoneModal: FC<PhoneModalProps> = ({
  isOpen = false,
  onConfirm
}) => {

	const modalRoot = document.getElementById('modal-root');
  const [ isDisabled, setIsDisabled ] = useState<boolean>(true);

  const { register, getValues, setValue } = useForm<FormValues>({
    defaultValues: {
      phone: ''
    }
  })
  const registerWithMask = useHookFormMask(register);
  const phoneMask = useRef('+7 (999) 999-99-99');

  useEffect(() => {
    setIsDisabled(getValues().phone.replace(/[^\d]/g, '').length !== 11);
    if (!isOpen) {
      setValue('phone', '');
    } else {
      document.getElementById('confirm-phone-input')?.focus();
    }
  }, [getValues, isOpen, setValue])

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.value.replace(/[^\d]/g, '').length === 11) {
      setValue('phone', event.target.value);
    }

    setIsDisabled(getValues().phone.replace(/[^\d]/g, '').length !== 11);
  }

  const onClick = () => {
    console.log(getValues().phone.replace(/[^\d]/g, ''))
    if (getValues().phone.replace(/[^\d]/g, '').length !== 11) return;

    bookingStore.setPhone(getValues().phone);
    bookingStore.setIsPhoneConfirmed(true);

    onConfirm?.();
  }

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();

      setTimeout(() => {
        onClick();
      }, 10);
    }
  }

  if (!isOpen||!modalRoot) return <></>
  
  return ReactDOM.createPortal(
    <div className={styles.phoneModal}>
      <div className={styles.phoneModal__overlay}></div>
      <form className={styles.phoneModal__body}>
        <div className={styles.phoneModal__name}>Укажите ваш номер телефона</div>
        <input 
          enterKeyHint='done'
          type="text" 
          id='confirm-phone-input'
          className={styles.phoneModal__input} 
          {...registerWithMask('phone', [phoneMask.current], {
            inputmode: 'numeric',
            onBeforeMask: (initialValue) => {
              if (initialValue.startsWith('89')) {
                return initialValue.replace('8', '');
              }

              if (initialValue.startsWith('7')) {
                return initialValue.replace('7', '');
              }

              return initialValue;
            },
            validate: value => {
              if (value.replace(/[^\d]/g, '').length !== 12) {
                return 'Некорректный номер телефона';
              }
            },
          })}
          onChange={onChange}
          onKeyDown={onKeyDown}
        />
      <ButtonContained
        variant={isDisabled ? 'secondary' : 'primary'}
        className={styles.phoneModal__button}
        disabled={isDisabled}
        onClick={onClick}
        type='button'
      >
        Подтвердить
      </ButtonContained>
      </form>
    </div>,
    modalRoot)
}